/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  PharmacyDirectory,
} from '../models';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    PharmacyDirectoryFromJSON,
    PharmacyDirectoryToJSON,
} from '../models';

export interface GetPharmaciesRequest {
    name?: string;
    limit?: number;
}

export interface GetPharmacyRequest {
    id: string;
}

/**
 * 
 */
export class PharmaciesApi extends runtime.BaseAPI {

    /**
     * Returns all Pharmacies (Roles: physician, admin, patient)
     */
    async getPharmaciesRaw(requestParameters: GetPharmaciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PharmacyDirectory>>> {
        const queryParameters: any = {};

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/pharmacies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PharmacyDirectoryFromJSON));
    }

    /**
        Request Config Getter
     */
    getPharmaciesRequestOptionsRaw(requestParameters: GetPharmaciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/pharmacies`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Returns all Pharmacies (Roles: physician, admin, patient)
     */
    async getPharmacies(requestParameters: GetPharmaciesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PharmacyDirectory>> {
        const response = await this.getPharmaciesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a single Pharmacy from the directory by id (Roles: physician, admin, patient)
     */
    async getPharmacyRaw(requestParameters: GetPharmacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PharmacyDirectory>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPharmacy.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/pharmacies/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PharmacyDirectoryFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getPharmacyRequestOptionsRaw(requestParameters: GetPharmacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPharmacy.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/pharmacies/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Returns a single Pharmacy from the directory by id (Roles: physician, admin, patient)
     */
    async getPharmacy(requestParameters: GetPharmacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PharmacyDirectory> {
        const response = await this.getPharmacyRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
